import {createStore} from 'vuex'

export default createStore({
    state: {
        productsList: null,
        categories: null,
        highlightSame: false,
        activeCategory: null,
    },
    mutations: {
        changeItemsSorting(state, {catId, items}) {
            state.categories.find(i => i.ID === catId).items = items
        },
        changeProductsSorting(state, {value}) {
            state.productsList = value
        },
        setProductsList(state, {value}) {
            state.productsList = value
        },
        setCategoriesList(state, {value}) {
            state.categories = value
            state.activeCategory = state.categories[0].ID
        },
        setActiveCategory(state, {value}) {
            state.activeCategory = value
        },
        sortItems(state) {
            state.categories.forEach((cat) => {
                cat['items'] = []
                state.productsList.forEach((product) => {
                    if (product.categoryId === cat.ID) {
                        cat['items'].push(product)
                    }
                })
            })
        },
        clearProductsList(state){
            state.productsList = null
            state.categories.forEach((cat) => {
                cat['items'] = []
            })
            window.location.reload()
        },
        deleteProduct(state, {prodId, catId}) {
            if (!prodId) return
            state.productsList.splice(state.productsList.findIndex(i => i.id === prodId), 1)
            let categoryIndex = state.categories.findIndex(i => i.ID === catId)
            if (state.categories[categoryIndex].items.length > 1) {
                state.categories[categoryIndex].items.splice(state.categories[categoryIndex].items.findIndex(i => i.id === prodId), 1)
            } else {
                if (state.categories.length > 1) {
                    state.categories.splice(categoryIndex, 1)
                    state.activeCategory = state.categories[0].ID
                } else {
                    window.location.reload()
                }
            }

        },
        toggleHighlight(state, {val}) {
            state.highlightSame = val
        }
    },
    actions: {
        async loadProducts({commit}) {
            let response
            if (window.currentProduct) {
                response = await fetch(`/api/product/compare/?sectionId=${window.currentProduct.sectionId}&id=${window.currentProduct.id}`, {
                    method: 'GET'
                })
                if (response.ok) {
                    let data = await response.json()
                    if (Array.isArray(data)) {
                        commit('setProductsList', {
                            value: data
                        })
                    } else {
                        commit('setProductsList', {
                            value: Object.values(data)
                        })
                    }
                    return true
                } else {
                    console.log(response.error)
                    return false
                }
            } else {
                response = await fetch(`/api/compare/`, {
                    method: 'GET'
                })
                if (response.ok) {
                    let data = await response.json()
                    commit('setProductsList', {
                        value: data
                    })
                    return true
                } else {
                    console.log(response.error)
                    return false
                }
            }
            if (response.ok) {
                let data = await response.json()
                if (Array.isArray(data)) {
                    commit('setProductsList', {
                        value: data
                    })
                } else {
                    commit('setProductsList', {
                        value: Object.values(data)
                    })
                }

                return true
            } else {
                console.log(response.error)
                return false
            }
        },
        async loadCategories({commit}) {
            let response = await fetch("/api/compare/categories/", {
                method: 'GET'
            })
            if (response.ok) {
                let data = await response.json()
                commit('setCategoriesList', {
                    value: data.data
                })
                return true
            } else {
                console.log(response.error)
                return false
            }
        },
        async clearComparsion({commit}) {
            let response = await fetch("/api/compare/clear/", {
                method: 'POST'
            })
            if (response.ok) {
                commit('clearProductsList')
            } else {
                console.log(response.error)
            }
        },
        async deleteProduct({commit}, {prodId, catId}) {
            let response = await fetch(`/api/compare/delete/?id=${prodId}`, {
                method: 'POST'
            })
            if (response.ok) {
                commit('deleteProduct', {
                    prodId: prodId,
                    catId: catId
                })
            } else {
                console.log(response.error)
            }
        },
    },
    modules: {}
})
